<template>
  <div>
    <router-view />
  </div>
</template>
<script>
import { isJSONString } from "@/utils/utils";
import { hasYjbParameter } from "@/utils/intConfiguration"
export default {
  data() {
    return {
      dictionary: [
        {
          hostname: 'lowcode',
          title: '低代码平台',
          ico: 'linggekj_logo',
        },
        {
          hostname: 'console',
          title: '租户管理平台',
          ico: 'linggekj_logo',
        },
       {
          hostname: 'equipment',
          title: '医装智能分析平台',
          ico: 'linggekj_logo',
        },
        {
          hostname: 'lingbolive',
          title: '灵播管家',
          ico: 'lingbolive_logo',
        },
        {
          hostname: 'admin',
          title: '灵播管家',
          ico: 'lingbolive_logo',
        },
        {
          hostname: 'lingbomanager',
          title: '灵播管家',
          ico: 'lingbolive_logo',
        },
        {
          hostname: 'workflow',
          title: '审批中转',
          ico: 'linggekj',
        },
      ],
    };
  },
  mounted() {
    const uiInfo = JSON.parse(localStorage.getItem("uiInfo")) || {};
    if (!isJSONString(uiInfo)) {
      // TODO 兜底ico和title
      const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < this.dictionary.length; i++) {
        if (window.location.hostname.toString().includes(this.dictionary[i].hostname)) {
          try {
            const _res = JSON.parse(localStorage.getItem('ui_fitment'));
            if(_res) {
              if(_res.homeTitle) {
                document.title = _res.homeTitle;
              }else {
                document.title = this.dictionary[i].title;
              }
              if(_res.browserIco) {
                link.href = _res.browserIco;
              }else {
                link.href = `./ico/${this.dictionary[i].ico}.ico`;
              }

            }else {
            document.title = this.dictionary[i].title;
             link.href = `./ico/${this.dictionary[i].ico}.ico`;
            }
          } catch (error) {
            document.title = this.dictionary[i].title;
             link.href = `./ico/${this.dictionary[i].ico}.ico`;
          }
        }
      }
    }
  }
};

</script>
